import { useEffect } from 'react'

import { toNumber } from 'lodash'
import { useSelector } from 'react-redux'

import { EndUser } from '@driftt/api-types'
import { getDriftWebSocket } from '@driftt/drift-ws'

import { useDriftWS } from 'hooks/useDriftWS'
import useEndUserPresenceStore from 'layouts/RealTimeDashboard/hooks/useEndUserPresenceStore'
import * as OrgSelectors from 'modules/org/selectors'

const END_USER_TYPE = 2
const LEAD_USER_TYPE = 4

export const useEndUserPresenceSubscription = (
  endUsers: EndUser[]
): Set<number> => {
  const socketSetupComplete = useDriftWS()
  const { presentEndUserIds, setEndUserPresent } = useEndUserPresenceStore()
  const orgId = useSelector(OrgSelectors.orgId)

  useEffect(() => {
    if (socketSetupComplete) {
      const ws = getDriftWebSocket()
      const subs = [...endUsers].map((endUser) =>
        ws
          .on<any>({
            cluster: 'chat',
            channelName: `user_presence:${orgId}-${endUser.id}-${
              endUser.type === 'END_USER' ? END_USER_TYPE : LEAD_USER_TYPE
            }`,
            messageName: 'presence:update',
          })
          .subscribe(() => {
            setEndUserPresent(toNumber(endUser.id))
          })
      )
      return () => {
        subs.forEach((sub) => sub.unsubscribe())
      }
    }
  }, [socketSetupComplete, orgId, endUsers, setEndUserPresent])

  return presentEndUserIds
}
